import React, { useState, useEffect,useRef } from 'react';
import Button from '../ui/Button';
import { HiMiniFaceSmile } from 'react-icons/hi2';
import data from '@emoji-mart/data'
import Picker from '@emoji-mart/react'
import styles from './StatusEditorPopup.module.css';


const StatusEditorPopup = ({ uid, svalue, onClose, onChange, onSave }) => {
  const [emojiPickerOpen, setEmojiPickerOpen] = useState(null);
  const [statusDraft, setStatusDraft] = useState(svalue);
   const emojiClickRef = useRef(false);
  const inputRefs = useRef({});
  const caretPos = useRef({});  
 
 console.log(svalue);
 
	useEffect(() => {
		const input = inputRefs.current[uid];
		input?.focus();
		input?.setSelectionRange(statusDraft.length, statusDraft.length);
	}, []);

	const handleEmojiSelect = (emoji) => {
	  const currentText = statusDraft || '';
	  const input = inputRefs.current[uid];
	  const caret = caretPos.current[uid] ?? currentText.length;

	  const before = currentText.slice(0, caret);
	  const after = currentText.slice(caret);
	  const updated = `${before}${emoji.native}${after}`;

		//console.log(before, after, updated)

	  setStatusDraft((prev) => {
		caretPos.current[uid] = caret + emoji.native.length;
		return updated;
	  });

	  // Focus & move caret
	  setTimeout(() => {
		if (input) {
		  input.focus();
		  input.setSelectionRange(caretPos.current[uid], caretPos.current[uid]);
		}
	  }, 0);
	};

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.popup} onClick={(e) => e.stopPropagation()}>
		<textarea
		  ref={(el) => (inputRefs.current[uid] = el)}
		  value={statusDraft ?? ''}
		  onChange={(e) => {const value = e.target.value.slice(0, 500); setStatusDraft(value);}}
			style={{ height: 'auto' }}
			onInput={(e) => {
			  e.target.style.height = 'auto';
			  e.target.style.height = `${e.target.scrollHeight}px`;
			}}
		  onSelect={(e) => { caretPos.current[uid] = e.target.selectionStart; }}
		  className={styles.textarea}
		  rows={2}
		  placeholder="Set your status..." />

        <div className={styles.footer}>
			<Button className={styles.emojiBtn}
			  onMouseDown={() => {
				emojiClickRef.current = true;
				setEmojiPickerOpen(emojiPickerOpen === uid ? null : uid);
				setTimeout(() => (emojiClickRef.current = false), 200);
			  }}>
			  <HiMiniFaceSmile size={18} />
			</Button>
          <span className={styles.counter}>{statusDraft.length} / 500</span>
          <div className={styles.actions}>
		    <Button variant="secondary" onClick={() => {setStatusDraft(''); onChange(""); caretPos.current[uid] = 0;}}>Clear</Button>
            <Button variant="ghost" onClick={() => {onClose(); }}>Cancel</Button>
            <Button variant="primary" onClick={() => {onChange(statusDraft); onSave(statusDraft)}}>Save</Button>			
          </div>
        </div>
		{emojiPickerOpen === uid && (
		  <div className={styles.pickerContainer}>
			<Picker data={data} onEmojiSelect={(emoji) => handleEmojiSelect(emoji)}  theme="dark" />
		  </div>
		)}
      </div>
    </div>
  );
};

export default StatusEditorPopup;
